import styled from "styled-components";

const StyleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 24px;

    background: #F2F3F5;
    border-radius: 8px;
    @media only screen and (max-width: 786px) {
        padding: 0;
    }
`;

export default StyleWrapper;